import { render, staticRenderFns } from "./GeneralDashboard.vue?vue&type=template&id=68d1aeba&scoped=true&"
import script from "./GeneralDashboard.vue?vue&type=script&lang=js&"
export * from "./GeneralDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDashboard.vue?vue&type=style&index=0&id=68d1aeba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1aeba",
  null
  
)

export default component.exports